<template>
    <!-- breadcrumb-area-start -->
    <div class="it-breadcrumb-area it-breadcrumb-bg"
        :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
        <div class="container">
            <div class="row ">
                <div class="col-md-12">
                    <div class="it-breadcrumb-content z-index-3 text-center">
                        <div class="it-breadcrumb-title-box">
                            <h3 class="it-breadcrumb-title">COURSES</h3>
                        </div>
                        <div class="it-breadcrumb-list-wrap">
                            <div class="it-breadcrumb-list">
                                <span><a href="#">HOME</a></span>
                                <span class="dvdr">//</span>
                                <span>COURSES</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- breadcrumb-area-end -->

    <!-- course-area-start -->
    <div class="it-course-area it-course-style-2 it-course-style-5 p-relative pt-120 pb-120">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 mb-30">
                    <div class="it-course-2-wrap d-flex align-items-center">
                        <div class="it-course-thumb  p-relative">
                            <a href="#"><img src="/img/course/C1.png" alt=""></a>
                            <div class="it-course-thumb-text">
                                <span>B.M.S</span>
                            </div>
                        </div>
                        <div class="it-course-content">
                            <h4 class="it-course-title pb-15"><a href="#">Bachelor of Management
                                    Studies (BMS)</a></h4>
                            <div class="it-course-info pb-20 mb-25 d-flex justify-content-between">
                                <span><i class="fa-light fa-file-invoice"></i>Regular</span>
                                <span><i class="fa-sharp fa-regular fa-clock"></i>3 years course</span>
                                <span><i class="fa-light fa-user"></i>60 students</span>
                            </div>
                            <div>
                                <ul>
                                    <li><a href="/documents/FYBMS_SYLLABUS.pdf" target="_blank">FY B.M.S Syllabus </a> </li>
                                    <li><a href="#">SY B.M.S Syllabus </a> </li>
                                    <li><a href="#">TY B.M.S Syllabus </a></li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-xl-6 col-lg-6 mb-30">
                    <div class="it-course-2-wrap d-flex align-items-center">
                        <div class="it-course-thumb  p-relative">
                            <a href="#"><img src="/img/course/C2.png" alt=""></a>
                            <div class="it-course-thumb-text">
                                <span>M.M.S</span>
                            </div>
                        </div>
                        <div class="it-course-content">
                            <h4 class="it-course-title pb-15"><a href="#">Master of Managment and
                                    Studies (MMS)</a></h4>
                            <div class="it-course-info pb-20 mb-25 d-flex justify-content-between">
                                <span><i class="fa-light fa-file-invoice"></i>Regular</span>
                                <span><i class="fa-sharp fa-regular fa-clock"></i>2 years course</span>
                                <span><i class="fa-light fa-user"></i>60 students</span>
                            </div>
                            <div>
                                <ul>
                                    <li><a href="/documents/FYMMS_Syllabus.pdf" target="_blank">FY M.M.S Syllabus</a>
                                    </li>
                                    <li><a href="/documents/SYMMS_Syllabus.pdf" target="_blank">SY M.M.S Syllabus </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- course-area-end -->
</template>
<script>
export default {
    name: "coursesView"
};
</script>
